"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hubSpotEventsService = void 0;
const PORTAL_ID = REACT_APP_HUBSPOT_PORTAL_ID;
class HubSpotEventsService {
    constructor() {
        Object.defineProperty(this, "isLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "eventQueue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    initialize() {
        if (!PORTAL_ID) {
            console.warn('[HubSpot] REACT_APP_HUBSPOT_PORTAL_ID is not set, skipping');
            return;
        }
        if (this.isLoaded)
            return;
        const script = document.createElement('script');
        script.id = 'hs-script-loader';
        script.src = `//js.hs-scripts.com/${PORTAL_ID}.js`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            this.isLoaded = true;
            console.debug('[HubSpot] Tracking script loaded, portal:', PORTAL_ID);
            this.flushQueue();
        };
        document.head.appendChild(script);
        window._hsq = window._hsq || [];
    }
    trackEvent(eventName, properties = {}) {
        if (!PORTAL_ID)
            return;
        const _hsq = (window._hsq = window._hsq || []);
        _hsq.push([
            'trackCustomBehavioralEvent',
            {
                name: eventName,
                properties,
            },
        ]);
    }
    identify(email) {
        if (!PORTAL_ID)
            return;
        const _hsq = (window._hsq = window._hsq || []);
        _hsq.push(['identify', { email }]);
    }
    trackFeatureActionPerformed(featureId, actionType) {
        this.trackEvent('pe' + PORTAL_ID + '_feature_action_performed', { feature_id: featureId, action_type: actionType });
    }
    trackFeatureAdopted(featureId) {
        this.trackEvent('pe' + PORTAL_ID + '_feature_adopted', { feature_id: featureId });
    }
    flushQueue() {
        this.eventQueue.forEach(({ eventName, properties }) => {
            this.trackEvent(eventName, properties);
        });
        this.eventQueue = [];
    }
}
exports.hubSpotEventsService = new HubSpotEventsService();
